<template>
  <el-drawer v-model="dialog" :with-header="false" :size="size" class="drawer-wrap">
    <header class="drawer-header">
      <i class="ico-close" @click="close()"><svg-icon name="close" /></i>
      <h3>
        <span>{{ title }}</span>
      </h3>
      <a v-if="downloadUrl" :download="downloadFileName" :href="downloadUrl" @click="download" class="ico-download" ><svg-icon name="download" /></a>
    </header>
    <div class="drawer-content" v-if="dataType === 'summary'">
      <div class="filter">
        <div style="flex: 1;">
        </div>

        <el-radio-group v-model="isYearly">
          <el-radio-button :value="false">Monthly</el-radio-button>
          <el-radio-button :value="true">Yearly</el-radio-button>
        </el-radio-group>
      </div>

      <el-table :data="data" v-loading="loading">
        <el-table-column prop="select_date" label="Date">
          <template #default="scope">
            {{ moment(scope.row?.select_date).format(isYearly ? 'YYYY' : 'MMMM ‘YY') }}
          </template>
        </el-table-column>
        <el-table-column prop="merchant_account_name" label="Source" />
        <el-table-column prop="sales_total" label="Sales" />
        <el-table-column prop="sale_value_total" label="Sales Value">
          <template #default="scope">
            {{ FormatMoney(scope.row?.sale_value_total) }}
          </template>
        </el-table-column>
        <el-table-column prop="earnings_total" label="Earned" width="80">
          <template #default="scope">
            {{ FormatMoney(scope.row?.earnings_total) }}
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="!loading && !isEnd" class="w-100" :loading="loadingMore" @click="getData(true)">Load more</el-button>
      <p v-else-if="!loading" class="no-more">No more to display</p>
    </div>


    <div class="drawer-content" v-else-if="dataType === 'transactions'">
      <p class="tip">Updated daily.</p>
      <div class="select-date">
        <div class="left">
          <DatePicker class="btn" :date_range="dateRange" @update-date="selectDate" :is_append_to_body="false" :is_use_current_text="true" :cus_text="cus_text"
          :key="dateRange.start_date + dateRange.end_date" />
          <!-- <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <svg-icon name="calendar" />
              {{ dates.find((o) => o.active).name }}
              <svg-icon name="menu-arrow" />
            </span>
            
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="date in dates" :key="date.value" @click="selectDate(date)">{{
                  date.name
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown> -->
          <!-- <time>{{ startDate.format('MMM DD, YYYY') }} - {{ endDate.format('MMM DD, YYYY') }}</time> -->
        </div>
        <div class="right">
          <label>Total earnings (USD)</label>
          <strong>{{ FormatMoney(totalEarnings) }}</strong>
        </div>
      </div>

      <!-- <div class="filter">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            Source: {{ sources.find((o) => o.active).name }} <svg-icon name="menu-arrow" />
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="source in sources" :key="source.value" @click="selectSource(source)">{{
                source.name
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div> -->

      <el-table :data="data" v-loading="loading" class="product-table" @row-click="openProduct">
        <el-table-column prop="transaction_date" label="Date" :width="120">
          <template #default="scope">
            {{ moment(scope.row.transaction_date).format('MMM DD, YYYY') }}
          </template>
        </el-table-column>
        <el-table-column prop="product_detail" label="Item" :width="300">
          <template #default="scope">
            <div class="product-info" v-if="scope.row.product_detail">
              <el-image
                style="width: 54px; height: 54px"
                :src="scope.row.product_detail.images.img_200x200"
                fit="contain"
              />
              <h4>{{ scope.row.product_detail.name }}</h4>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="creator_portal_merchant_name" label="Merchant" /> -->
        <el-table-column prop="creator_portal_source_name" label="Source" />
        <!-- <el-table-column prop="sales_value" label="Sales Value">
          <template #default="scope">
            {{ FormatMoney(scope.row.sale_value) }}
          </template>
        </el-table-column> -->
        <el-table-column prop="earnings" label="Earnings" width="110">
          <template #default="scope">
            <span>{{ FormatMoney(scope.row.earnings) }}</span>
            {{ scope.row.is_payable === 1 ? 'Paid' : 'Pending' }}
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="!loading && !isEnd" class="w-100" :loading="loadingMore" @click="getData(true)"
        >Load more</el-button
      >
      <p v-else-if="!loading" class="no-more">No more to display</p>
    </div>
    <div class="drawer-content" v-else-if="dataType === 'product'">
      <p class="tip">Updated daily</p>
      <div class="product" v-if="product.id">
        <el-image style="width: 60px; height: 60px" :src="product.images.img_200x200" fit="cover" />
        <div class="info">
          <h4>{{ product.name }}</h4>
          <p>{{ product.brand.name }}</p>
        </div>
      </div>
      <div class="select-date">
        <div class="left">
          <DatePicker class="btn" :date_range="dateRange" @update-date="selectDate" :is_append_to_body="false" :is_use_current_text="true" :cus_text="cus_text"
          :key="dateRange.start_date + dateRange.end_date" />

          <!-- <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <svg-icon name="calendar" />
              {{ dates.find((o) => o.active).name }}
              <svg-icon name="menu-arrow" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="date in dates" :key="date.value" @click="selectDate(date)">{{
                  date.name
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <time>{{ startDate.format('MMM DD, YYYY') }} - {{ endDate.format('MMM DD, YYYY') }}</time> -->
        </div>
        <div class="right">
          <label>Total earnings (USD)</label>
          <strong>{{ FormatMoney(totalEarnings) }}</strong>
        </div>
      </div>

      <el-table :data="data" v-loading="loading" class="product-table">
        <el-table-column prop="transaction_date" label="Date">
          <template #default="scope">
            {{ moment(scope.row.transaction_date).format('MMM DD, YYYY') }}
          </template>
        </el-table-column>
        <el-table-column prop="creator_portal_merchant_name" label="Merchant" />
        <el-table-column prop="creator_portal_source_name" label="Source" />
        <el-table-column prop="sales_value" label="Sales Value">
          <template #default="scope">
            {{ FormatMoney(scope.row.sale_value) }}
          </template>
        </el-table-column>
        <el-table-column prop="commissions" label="Earnings">
          <template #default="scope">
            <span>{{ FormatMoney(scope.row.earnings) }}</span>
            {{ scope.row.is_payable === 1 ? 'Paid' : 'Pending' }}
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="!loading && !isEnd" class="w-100" :loading="loadingMore" @click="getData(true)"
        >Load more</el-button
      >
      <p v-else-if="!loading" class="no-more">No more to display</p>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from 'vue';
import moment from 'moment';
import DatePicker from '@/components/ui/DatePicker.vue';
import { ElTable, ElTableColumn, ElImage, ElDrawer, ElDropdown, ElDropdownMenu, ElDropdownItem, ElRadioGroup, ElRadioButton, vLoading, ElButton } from 'element-plus';
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;

const emit = defineEmits(['open-product', 'close-edit-payment']);
const props = defineProps({
  is_sub: {
    default: false,
    type: Boolean,
  },
  user_id: {
    default: '',
    type: String,
  },
  FormatMoney: {
    type: Function,
    default: () => {},
  },
  user_joined_date: {
    type: String,
    default: '',
  },
});

let width = 'calc(100% - 200px)';
if (window.innerWidth < 768) {
  width = '100%';
} else if (props.is_sub) {
  width = 'calc(100% - 300px)';
}

const dialog = ref(false);
const size = ref(width);
const page = ref(1);
const isYearly = ref(false);
const loading = ref(false);
const loadingMore = ref(false);
const title = ref('Summary');
const data = ref([]);
const dataType = ref('');
const isEnd = ref(false);
const product = ref({});
const totalEarnings = ref(0);
const downloadUrl = ref('');
const downloadFileName = ref('');
const dateRange = ref({
  start_date: moment(props.user_joined_date).toDate(),
  end_date: moment().toDate(),
});
const cus_text = ref('Lifetime');
const sources = ref([
  {
    value: 'all',
    name: 'All',
    active: true,
  },
]);

// const dates = ref([
//   {
//     name: 'All time',
//     value: 'all',
//     active: true,
//   },
//   {
//     name: 'Last 30 days',
//     value: '30',
//     active: false,
//   },
//   {
//     name: 'Last 60 days',
//     value: '60',
//     active: false,
//   },
//   {
//     name: 'Last 90 days',
//     value: '90',
//     active: false,
//   },
//   {
//     name: 'Last 365 days',
//     value: '365',
//     active: false,
//   },
// ]);

// const startDate = ref(moment('2020-12-01'));
// const endDate = ref(moment());

watch(isYearly, () => {
  getData();
});

const open = (type, obj = {}) => {
  dataType.value = type;
  dialog.value = true;
  cus_text.value = 'Lifetime';
  // startDate.value = moment('2020-12-01');
  // endDate.value = moment();

  dateRange.value = {
    start_date: moment(props.user_joined_date).toDate(),
    end_date: moment().toDate(),
  };
  // sources.value.forEach((source) => {
  //   source.active = source.value === 'all';
  // });
  sources.value = [
    {
      value: 'all',
      name: 'All',
      active: true,
    },
  ];
  // dates.value.forEach((date) => {
  //   date.active = date.value === 'all';
  // });

  if (type === 'product') {
    product.value = obj;
  }

  getData();
};

const close = () => {
  dialog.value = false;

  if (dataType.value === 'edit-payment') {
    emit('close-edit-payment');
  }
};

const getData = (is_next = false) => {
  if (is_next) {
    page.value++;
    loadingMore.value = true;
  } else {
    page.value = 1;
    data.value = [];
    isEnd.value = false;
    loading.value = true;
    downloadUrl.value = '';
    downloadFileName.value = '';
  }

  switch (dataType.value) {
    case 'summary':
      title.value = 'Summary';
      downloadUrl.value = `/creator/transaction-summary-by-anchor-merchants-detail?anchor_creator_id=${props.user_id}&for_download=1${isYearly.value ? '&summary_type=year' : ''}`;
      downloadFileName.value = 'summary.csv';
      getSummaryData(is_next);
      // getSources(true);
      break;

    case 'transactions':
      title.value = 'Bonus Earnings';
      downloadUrl.value = `/creator/transactions?anchor_creator_id=${props.user_id}&for_download=1&start_date=${moment(dateRange.value.start_date).format('YYYY-MM-DD')}&end_date=${moment(dateRange.value.end_date).format('YYYY-MM-DD')}`;
      downloadFileName.value = 'transactions.csv';
      getTransactionsData(is_next);
      // getSources();
      break;

    case 'product':
      getProductData(is_next);
      title.value = 'Product Earning Details';
      break;
  }
};

const download = (e) => {
  e.preventDefault();
  const base = ajax.defaults.baseURL === '/api/v1' ? '' : ajax.defaults.baseURL;
  const url = base + downloadUrl.value;
  const fileName = downloadFileName.value;
  const a = document.createElement('a');

  ajax.get(url).then((res) => {
    const blob = new Blob([res.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  });
};

const getSummaryData = (is_next) => {
  const type = isYearly.value ? 'year' : 'month';
  let api = `/creator/transaction-summary-by-anchor-merchants-detail?anchor_creator_id=${props.user_id}&page=${page.value}&summary_type=${type}`;

  if (sources.value.length > 1) {
    const source = sources.value.find((o) => o.active);
    if (source.value !== 'all') api += `&merchant_source=${source.value}`;
  }

  ajax.get(api).then((res) => {

    res.data.data.data.data.forEach((item) => {
      data.value.push(item);
    });

    loading.value = false;
    loadingMore.value = false;
    isEnd.value = page.value === res.data.data.data.total;
  });
};

const getTransactionsData = (is_next) => {
  let api = `/creator/transactions?anchor_creator_id=${props.user_id}&page=${page.value}`;

  // if (sources.value.length > 1) {
  //   const source = sources.value.find((o) => o.active);
  //   if (source.value !== 'all') api += `&merchant_source=${source.value}`;
  // }

  // if (dates.value.length > 1) {
  //   const date = dates.value.find((o) => o.active);
  //   if (date.value !== 'all') {
  //     api += `&start_date=${startDate.value.format('YYYY-MM-DD')}&end_date=${endDate.value.format('YYYY-MM-DD')}`;
  //   }
  // }

  api += `&start_date=${moment(dateRange.value.start_date).format('YYYY-MM-DD')}&end_date=${moment(dateRange.value.end_date).format('YYYY-MM-DD')}`;

  ajax.get(api).then((res) => {
    const r = res.data.data.data;
    r.rows.data.forEach((item) => {
      data.value.push(item);
    });

    totalEarnings.value = r.earnings;

    loading.value = false;
    loadingMore.value = false;
    isEnd.value = page.value === r.rows.last_page;
  });
};

const getProductData = (is_next) => {
  let api = `/creator/transactions?anchor_creator_id=${props.user_id}&product_id=${product.value.id}&page=${page.value}`;

  if (sources.value.length > 1) {
    const source = sources.value.find((o) => o.active);
    if (source.value !== 'all') api += `&merchant_source=${source.value}`;
  }

  // if (dates.value.length > 1) {
  //   const date = dates.value.find((o) => o.active);
  //   if (date.value !== 'all') {
  //     api += `&start_date=${startDate.value.format('YYYY-MM-DD')}&end_date=${endDate.value.format('YYYY-MM-DD')}`;
  //   }
  // }

  api += `&start_date=${moment(dateRange.value.start_date).format('YYYY-MM-DD')}&end_date=${moment(dateRange.value.end_date).format('YYYY-MM-DD')}`;

  ajax.get(api).then((res) => {
    const r = res.data.data.data;
    r.rows.data.forEach((item) => {
      data.value.push(item);
    });

    totalEarnings.value = r.earnings;

    loading.value = false;
    loadingMore.value = false;
    isEnd.value = page.value === r.rows.last_page;
  });
};


// const getSources = (is_for_summary = false) => {
//   if (sources.value.length === 1)
//     ajax.get(`/creator/transaction-summary-by-anchor-merchants-detail/merchant-source-list${is_for_summary ? '?for_summary=1' : ''}&anchor_creator_id=${props.user_id}`).then((res) => {
//       res.data.data.data.data.forEach((source) => {
//         source.active = false;
//         sources.value.push(source);
//       });
//     });
// };

// const selectSource = (o) => {
//   sources.value.forEach((source) => {
//     source.active = o.value === source.value;
//   });

//   getData();
// };

const selectDate = (o) => {
  cus_text.value = o.cus;

  dateRange.value = {
    start_date: moment(o.start_date).toDate(),
    end_date: moment(o.end_date).toDate(),
  };

  // dates.value.forEach((date) => {
  //   date.active = o.value === date.value;
  // });

  // if (o.value === 'all') {
  //   startDate.value = moment('2020-12-01');
  //   endDate.value = moment();
  // } else {
  //   startDate.value = moment().subtract(o.value, 'days');
  //   endDate.value = moment();
  // }

  getData();
};

const statusText = (row) => {
  let text = '';
  let className = '';
  switch (row.status) {
    case 1:
      text = 'Completed';
      className = 'completed';
      break;
    case 0:
      text = 'Processing';
      className = 'processing';
      break;
    case -1:
      text = 'Rejected';
      className = 'rejected';
      break;
  }

  return `<label class="status-${className}">${text}</label>`;
};

const openProduct = (row) => {
  emit('open-product', row.product_detail);
};

defineExpose({
  open,
  close,
});
</script>

<style lang="scss">
.drawer-wrap .el-drawer__body {
  padding: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  background-color: var(--Bg-light);
}

.drawer-header {
  display: flex;
  align-items: center;
  // border-bottom: 1px solid var(--Border-default);
  padding: 16px 24px;
  position: sticky;
  background-color: var(--Bg-light);
  top: 0;
  z-index: 3;

  @media screen and (max-width: $mobile_size) {
    padding: 16px 8px;
  }

  h3 {
    flex: 1;
    font: var(--medium-20);
    color: var(--Text-primary);
  }

  .ico-close {
    cursor: pointer;
    height: 32px;
    width: 32px;
    margin-right: 8px;
    border-radius: var(--radius);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--Text-primary);
    transition: background-color 0.2s ease;

    svg {
      height: 16px;
      width: 16px;
    }

    &:hover {
      background-color: var(--Bg-02);
    }
  }

  .ico-download {
    cursor: pointer;
    height: 32px;
    width: 32px;
    border-radius: var(--radius);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--Text-default);
    transition: all 0.2s ease;

    svg {
      height: 16px;
      width: 16px;
    }

    &:hover {
      background-color: var(--Bg-02);
      color: var(--Text-primary);
    }
  }
}

.drawer-content {
  padding: 0 24px 24px;
  // overflow: hidden;

  @media screen and (max-width: $mobile_size) {
    padding: 0 16px 16px;
    width: 100%;
    box-sizing: border-box;
  }

  .product-info {
    display: flex;
    gap: 8px;
  }

  .tip {
    color: var(--Text-secondary);
    margin: 0 0 16px 0;
    font-size: 12px;
  }

  .product {
    display: flex;
    align-items: center;
    margin: 0 0 16px 0;

    .info {
      flex: 1;
      padding-left: 12px;
    }

    h4 {
      font: var(--medium-24);
      color: var(--Text-primary);
      margin: 0 0 6px 0;

      @media screen and (max-width: $mobile_size) {
        font: var(--medium-18);
      }
    }

    p {
      font: var(--medium-16);
      color: var(--Text-primary);
      margin: 0;

      @media screen and (max-width: $mobile_size) {
        font: var(--medium-14);
      }
    }
  }

  .no-more {
    color: var(--Text-secondary);
    margin: 16px 0 0 0;
    text-align: center;
  }

  .filter {
    display: flex;
    align-items: center;

    & > *:first-child {
      flex: 1;
    }
  }

  .status-processing {
    color: var(--Text-link);
    font: var(--medium-12);
  }

  .status-completed {
    color: var(--Text-safe);
    font: var(--medium-12);
  }

  .status-rejected {
    color: var(--Text-danger);
    font: var(--medium-12);
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border-color: var(--ui-color-primary);
  }

  .el-radio-button__inner {
    border-color: var(--ui-color-primary);
    padding: 0;
    width: 110px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font: var(--medium-12);
    color: var(--Text-primary);
  }

  .select-date {
    display: flex;
    align-items: center;
    margin: 16px 0;

    .left {
      position: relative;

      .mx-datepicker-popup {
        left: 0 !important;
        top: 100% !important;
      }
    }

    // .left {

    //   .el-dropdown-link {
    //     .svg-icon--calendar {
    //       height: 16px;
    //       width: 16px;
    //       margin-right: 6px;
    //     }
    //   }

    //   & > time {
    //     display: block;
    //     font: var(--medium-16);
    //     color: var(--Text-primary);
    //     margin-top: 2px;

    //     @media screen and (max-width: $mobile_size) {
    //       font: var(--medium-14);
    //     }
    //   }
    // }

    .right {
      flex: 1;
      text-align: right;

      label {
        font: var(--medium-14);
        color: var(--Text-primary);
        display: block;

        @media screen and (max-width: $mobile_size) {
          font: var(--medium-12);
        }
      }

      strong {
        font: var(--medium-20);
        color: var(--Text-primary);
        display: block;
        margin-top: 2px;

        @media screen and (max-width: $mobile_size) {
          font: var(--medium-16);
        }
      }
    }
  }

  .payment-frame-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .payment-frame {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}

.product-table tbody tr {
  cursor: pointer;
}
</style>
